/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 16,
    height: 16,
    viewBox: '0 0 424 424',
    data: '<g _fill="#010002"><path pid="0" d="M35 89C15 89 0 74 0 54s15-36 35-36h353c20 0 36 16 36 36s-16 35-36 35H35zM388 176c20 0 36 16 36 36s-16 35-36 35H35c-20 0-35-15-35-35s15-36 35-36h353zM388 335c20 0 36 15 36 35s-16 36-36 36H35c-20 0-35-16-35-36s15-35 35-35h353z"/></g>'
  }
})
